export const SHORT_NAME_LENGTH: number = 25;
export const MAX_NAME_LENGTH: number = 50;
